$(function () {
    $('[data-accordion]').accordion({
        collapsible: true,
        heightStyle: "content"
    });    
});
//faq accordion
function openFaq(questionId) {  
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */

    let clickedAccordionButton = $(".faq-accordion--button." + questionId);

    clickedAccordionButton.toggleClass('active');

    /* Toggle between hiding and showing the active panel */
    var panel = $(".faq-accordion--button." + questionId).next();

    if (panel.css('display') == "block") {
        panel.slideUp();
    } else {
        //hide all others
        let accordionButtons = $(".faq-accordion--button").not(clickedAccordionButton);
        accordionButtons.next().slideUp();
        accordionButtons.removeClass("active");
        panel.slideDown();
    }
};